export default "__VITE_ASSET__x_5Y$COQ__"